import { Box } from '@wix/design-system';
import { ChevronRightLarge } from '@wix/wix-ui-icons-common';
import React from 'react';
import { SwitchProductModule } from '../../../switch-product.module';
import { ProductBox } from './ProductBox';
export const CompareProducts = () => {
  const {
    t
  } = SwitchProductModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "change-product-modal-compare-products",
    verticalAlign: "middle",
    gap: "SP3",
    align: "space-between",
    direction: "horizontal"
  }, /*#__PURE__*/React.createElement(ProductBox, {
    dataHook: "existing-product-box",
    title: t('change_plan.change_plan_modal.current_plan'),
    isCurrentProduct: true
  }), /*#__PURE__*/React.createElement(Box, {
    height: "30px",
    width: "30px"
  }, /*#__PURE__*/React.createElement(ChevronRightLarge, {
    color: "#116dff"
  })), /*#__PURE__*/React.createElement(ProductBox, {
    dataHook: "target-product-box",
    title: t('change_plan.change_plan_modal.changing_to'),
    isCurrentProduct: false
  }));
};
//# sourceMappingURL=CompareProducts.js.map